import {
  ISimpleTableCellRenderProps,
  ISimpleTableField,
  ISimpleTableSort,
  ISimpleTableRow,
} from "./interface";
import { SimpleTable } from "./SimpleTable";

export { SimpleTable };
export type { ISimpleTableCellRenderProps, ISimpleTableField, ISimpleTableSort, ISimpleTableRow };
